import { Box, Grid, Typography, useTheme } from '@mui/material';
import { BarChart } from '@mui/x-charts';
import moment from 'moment';

const truncate = (text, max = 28) => {
  if (!text) return '';
  return text.length > max ? `${text.slice(0, max)}...` : text;
};

const CapacidadeDoMes = ({ data = [] }) => {
  const theme = useTheme();

  if (data?.length > 0) {
    return (
      <Grid item xs={12} md={6}>
        <Box gap={2} height="100%" display="flex" flexDirection="column">
          <Typography variant="h5" fontWeight="bold">
            Capacidade ({moment().format('MMM/YYYY')})
          </Typography>
          <Box mt="auto" width="100%">
            <BarChart
              layout="vertical"
              height={400}
              margin={{ left: 50, top: 50, right: 20, bottom: 100 }}
              series={[
                {
                  label: 'Eficiência',
                  data: data.map((item) => item.eficiencia),
                  valueFormatter: (value) => `${value} %`,
                  color: theme.palette.primary.dark,
                },
                {
                  label: 'Utilização',
                  data: data.map((item) => item.utilizacao),
                  valueFormatter: (value) => `${value} %`,
                  color: theme.palette.primary.light,
                },
                {
                  label: 'Disponibilidade',
                  data: data.map((item) => item.disponibilidade),
                  valueFormatter: (value) => `${value} %`,
                  color: theme.palette.primary.main,
                },
              ]}
              xAxis={[
                {
                  scaleType: 'band',
                  data: data.map((item) => truncate(item.setor, 18)),
                  categoryGapRatio: 0.25,
                  tickLabelStyle: {
                    angle: -35,
                    textAnchor: 'end',
                    fontSize: 11,
                  },
                },
              ]}
              yAxis={[
                {
                  min: 0,
                  max: 100,
                  valueFormatter: (value) => `${value} %`,
                },
              ]}
            />
          </Box>
        </Box>
      </Grid>
    );
  }

  return null;
};

export default CapacidadeDoMes;
